module.exports = __webpack_public_path__ + "img/img6-v2.b51adaa1.png";